/** ಕೆಲಸದ ವ್ಯವಸ್ಥೆ (ADR 0046): ಗಂಟೆ ಲೆಕ್ಕದಲ್ಲಿ, ಒಂದು ಸಲ, ವಾರದಲ್ಲಿ ಕೆಲವು ದಿನ, ಅಥವಾ ತಿಂಗಳ ಲೆಕ್ಕದಲ್ಲಿ. */
export const arrangement = {
    "question.arrangement": "ಕೆಲಸ ಎಷ್ಟು ಸಮಯಕ್ಕೆ?",
    "detail.arrangement": "ಎಷ್ಟು ಸಮಯಕ್ಕೆ",
    "arrangement.hourly": "ಗಂಟೆ ಲೆಕ್ಕದಲ್ಲಿ",
    "arrangement.visit": "ಒಂದು ಸಲ",
    "arrangement.weekly": "ವಾರದಲ್ಲಿ ಕೆಲವು ದಿನ",
    "arrangement.monthly": "ತಿಂಗಳ ಲೆಕ್ಕದಲ್ಲಿ",
    "unit.hour": "ಗಂಟೆಗೆ",
    "unit.visit": "ಒಂದು ಸಲಕ್ಕೆ",
    "unit.week": "ವಾರಕ್ಕೆ",
    "unit.month": "ತಿಂಗಳಿಗೆ",
    "price.per": "{unit} {price}",
    "estimate.range_week": "{city} ನಗರದಲ್ಲಿ {trade}{scope}: ಸಾಮಾನ್ಯವಾಗಿ ವಾರಕ್ಕೆ {low}–{high}.",
    "need.ask.arrangement": "ನಿಮಗೆ ಎಷ್ಟು ಸಮಯಕ್ಕೆ ಬೇಕು?",
    "need.arr.hourly": "ಕೆಲವು ಗಂಟೆ",
    "need.arr.visit": "ಒಂದೇ ಸಲ",
    "need.arr.weekly": "ವಾರದಲ್ಲಿ ಕೆಲವು ದಿನ",
    "need.arr.monthly": "ಪ್ರತಿ ತಿಂಗಳು",
    "need.arr.meal": "ಒಂದು ಊಟ ಅಥವಾ ಸಮಾರಂಭ",
    "need.field_arrangement": "ಎಷ್ಟು ಸಮಯಕ್ಕೆ",
    "need.summary_arrangement": "ಕೆಲಸ: {arrangement}.",
    "need.budget_per.hour": "ಇದು ಒಂದು ಗಂಟೆಗೆ ಗರಿಷ್ಠ.",
    "need.budget_per.visit": "ಇದು ಆ ಒಂದು ಸಲಕ್ಕೆ ಗರಿಷ್ಠ.",
    "need.budget_per.week": "ಇದು ಒಂದು ವಾರಕ್ಕೆ ಗರಿಷ್ಠ.",
    "need.budget_per.month": "ಇದು ಒಂದು ತಿಂಗಳಿಗೆ ಗರಿಷ್ಠ.",
    "iv.ask.arrangements": "ನೀವು ಯಾವ ರೀತಿಯ ಕೆಲಸ ತೆಗೆದುಕೊಳ್ಳುತ್ತೀರಿ? ಪ್ರತಿಯೊಂದನ್ನೂ ಟ್ಯಾಪ್ ಮಾಡಿ, ನಂತರ ಆಯಿತು ಒತ್ತಿ.",
    "iv.done": "ಆಯಿತು",
    "iv.err_arrangements": "ಕನಿಷ್ಠ ಒಂದು ರೀತಿಯ ಕೆಲಸ ಆಯ್ಕೆಮಾಡಿ.",
    "iv.picked": "ನೀವು ತೆಗೆದುಕೊಳ್ಳುವ ಕೆಲಸ: {list}.",
    "iv.ask.rate_hour": "ಒಂದು ಗಂಟೆಗೆ ಎಷ್ಟು ತೆಗೆದುಕೊಳ್ಳುತ್ತೀರಿ?",
    "iv.ask.rate_week": "ಒಂದು ವಾರಕ್ಕೆ ಎಷ್ಟು ತೆಗೆದುಕೊಳ್ಳುತ್ತೀರಿ?",
    "iv.summary_rate": "{arrangement}: {rate}.",
    "card.arrangements": "ನಾನು ತೆಗೆದುಕೊಳ್ಳುವ ಕೆಲಸ",
    "card.rate.hourly": "ಒಂದು ಗಂಟೆಯ ದರ, ₹",
    "card.rate.visit": "ಒಂದು ಸಲದ ದರ, ₹",
    "card.rate.weekly": "ಒಂದು ವಾರದ ದರ, ₹",
    "card.rate.monthly": "ಒಂದು ತಿಂಗಳ ದರ, ₹",
    "card.err_arrangements": "ಕನಿಷ್ಠ ಒಂದು ರೀತಿಯ ಕೆಲಸ ಆಯ್ಕೆಮಾಡಿ, ಪ್ರತಿಯೊಂದಕ್ಕೂ ದರ ಬರೆಯಿರಿ.",
    "card.radius": "ನಾನು ಎಷ್ಟು ದೂರ ಹೋಗುತ್ತೇನೆ",
    "card.km": "{km} ಕಿ.ಮೀ",
};
//# sourceMappingURL=arrangement.js.map